import template from './bVaAndNvaChart.html';
import moment from 'moment';
import d3 from 'd3';

const COLOR_NVA = '#FF644B';
const COLOR_VA = '#1C3828';

export function bVaAndNvaChartDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bVaAndNvaChartController,
    controllerAs: 'bVaAndNvaChart',
    bindToController: true,
    scope: {
      tooltipId: "@",
      data: "=",
      canShare: "=",
      onShareChart: "&",
      onExportChart: "&"
    }
  };
}

class bVaAndNvaChartController {
  constructor($filter, $scope, $translate, $rootScope, $routeParams) {
    'ngInject';

    this.$filter = $filter;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$routeParams = $routeParams;
    this.$translate = $translate;
    this.seriesVisibility = { series0: true, series1: true };
    this.vabm = [];
    this.chartData = [];
    this.maxYValue = 0;
    this.singleValue = false;
    this.updateChartOptions();
    this.$scope.$watch(() => this.data, newValue => this.updateChart(newValue));
  }

  exportChart() {
    this.$rootScope.exportProcessGroupVaAndNva = this.data;
    this.onExportChart({ exportData: { type: 'VaNva' } });
  }

  getMaxValue(data) {
    if (!data || !data.length) {
      return 0;
    }

    const summed = data.map(val => moment.duration(val.vaDuration).asHours() + moment.duration(val.nvaDuration).asHours());
    return Math.ceil(d3.max(summed)) * 1000 * 3600;
  }

  getRectTooltipPosition(node) {
    const bcr = node.getBoundingClientRect();
    return { top: bcr.top - 38, left: bcr.left - 30 };
  }

  shareChart() {
    const shareData = { type: 'va_and_nva' };
    this.onShareChart({ shareData });
  }

  updateChart(newValue) {
    if (!newValue) {
      return;
    }

    this.vabm = newValue;
    // TODO: Delete mocks before production launch
    // const vabm = [];
    // let date = moment('2019-11', 'YYYY-MM');
    // for (let i = 0; i < 11; i++) {
    //   date = date.subtract(1, 'month');
    //   vabm.unshift({
    //     date: date.format('YYYY-MM'),
    //     nvaDuration:  moment.duration(Math.floor(Math.random() * 200 * 3600*1000)).toJSON(),
    //     vaDuration:  moment.duration(Math.floor(Math.random() * 200 * 3600 * 1000)).toJSON()
    //   });
    // }

    const data = [
      {
        key: 'VA',
        color: COLOR_VA,
        values: []
      },
      {
        key: 'NVA',
        color: COLOR_NVA,
        values: []
      }
    ];
    this.vabm.forEach(item => {
      const month = item.date;
      data[0].values.push({ x: month, y: moment.duration(item.vaDuration).asMilliseconds() });
      data[1].values.push({ x: month, y: moment.duration(item.nvaDuration).asMilliseconds() });
    });

    this.maxYValue = this.getMaxValue(this.vabm);
    if (!this.maxYValue) {
      this.vabm = [];
      this.chartData = [
        {
          key: 'VA',
          color: COLOR_VA,
          values: []
        },
        {
          key: 'NVA',
          color: COLOR_NVA,
          values: []
        }
      ];
      return;
    }
    this.singleValue = data[0].values.length === 1;
    if (this.singleValue) {
      data.forEach(item => {
        const dateBefore = moment(this.vabm[0].date, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
        const dateAfter = moment(this.vabm[0].date, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
        item.values.push({ x: dateAfter, y: 0 });
        item.values.unshift({ x: dateBefore, y: 0 });
      });
    }

    this.chartData = data;
    this.$rootScope.bVaAndNvaCharData = angular.copy(this.data);
    this.updateChartOptions();
  }

  updateChartOptions() {
    const tooltipId = this.tooltipId;
    const filter = this.$filter;
    const chartSizeConst = {
      xTickPadding: 28,
      yTickPadding: 15,
      xLabelHeight: 20,
      chartHeight: 260
    };

    this.maxYValue = this.getMaxValue(this.vabm);
    this.chartOptions = {
      chart: {
        type: 'multiBarChart',
        noData: this.$translate.instant('NOTHING_TO_SHOW'),
        height: chartSizeConst.chartHeight,
        stacked: true,
        showControls: false,
        reduceXTicks: false,
        yDomain: [0, this.maxYValue ? this.maxYValue : 1],
        margin: {
          left: 70,
          right: 0,
          top: 0,
          bottom: chartSizeConst.xLabelHeight + chartSizeConst.xTickPadding
        },
        tooltip: {
          position: () => {
            const tooltipEl = angular.element(document.getElementById(`view-360-tooltip-${tooltipId}`));
            const parent = tooltipEl.parent();
            if (tooltipEl && parent && !parent.hasClass('view-360-tooltip')) {
              parent.addClass('view-360-tooltip');
            }

            const rect = angular.element(document.getElementsByClassName('hover'));
            if (!rect || !rect.length) {
              return {};
            }

            return this.getRectTooltipPosition(rect[0]);
          },
          contentGenerator: function (d) {
            const month = moment(d.data.x, 'YYYY-MM').format('MMMM').toUpperCase();
            const value = filter('hm')(moment.duration(d.series[0].value).toJSON());
            return `
                <div id="view-360-tooltip-${tooltipId}" class="view-360-tooltip-inner">
                 <div>${month}</div>
                 <div>${value}</div>
                </div>`;
          }
        },
        xAxis: {
          tickPadding: chartSizeConst.xTickPadding,
          tickValues: d => d[0].values.map(ym => ym.x),
          tickFormat: d => {
            if (this.singleValue && d !== this.vabm[0].date) {
              return '';
            }
            return moment(d).format('MMM').toUpperCase();
          }
        },
        yAxis: {
          showMaxMin: true,
          tickPadding: chartSizeConst.yTickPadding,
          tickValues: d => {
            const max = moment.duration(this.maxYValue).asHours();
            const ticksCount = Math.min(d[0].values.length, 6);
            let tickVal = parseInt(max / ticksCount);
            tickVal = tickVal ? tickVal : 1;
            const tickVals = [0];
            if (max === 0 || tickVal === 0) {
              return [0];
            }
            for (let t = tickVal; t <= max; t += tickVal) {
              tickVals.push(t);
            }
            return tickVals.map(val => val * 1000 * 3600);
          },
          tickFormat: d => {
            if (d < 0 || (d > 0 && d < 1000)) {
              return '';
            }
            return `${moment.duration(d).asHours()} h`;
          }
        }
      }
    };
  }

  hasSharedView() {
    return window.location.pathname.includes('shared');
  }

  toggleLegend(type) {
    if (!this.hasSharedView()) {
      this.seriesVisibility[type] = !this.seriesVisibility[type];
      if (!this.seriesVisibility['series0'] && !this.seriesVisibility['series1']) {
        this.seriesVisibility['series0'] = true;
        this.seriesVisibility['series1'] = true;
      }

      if (this.seriesVisibility['series0'] && this.seriesVisibility['series1']) this.$scope.value = "All";
      if (this.seriesVisibility['series0'] && !this.seriesVisibility['series1']) this.$scope.value = "Va";
      if (!this.seriesVisibility['series0'] && this.seriesVisibility['series1']) this.$scope.value = "Nva";

      this.$rootScope.toggleValueVaAndNvaChart = this.$scope.value;

      const nthChild = type === 'series0' ? 1 : 2;
      const legend = d3.select(`.bVaAndNvaChart .nv-series:nth-child(${nthChild})`).node();
      legend.dispatchEvent(new MouseEvent('click'));
    }
  }
}
